module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-13-92d379ddac49b05208d4b5f5d48c29c5.svg";